import _ from "lodash";
import { createSelector } from "reselect";

const cards = state => state.cards;
const insights = state => state.insights;
const tagFilter = state => state.tagFilter;
const topicFilter = state => state.topicFilter;

const attachInsightsToCards = createSelector(
  [cards, insights],
  (cards, insights) => {
    return cards.map((item, index) => {
      item.insight = insights[item.i];
      return item;
    });
  }
);

const applyFilterToCards = createSelector([attachInsightsToCards, tagFilter], (cards, tagFilter) => {
  if (_.isNull(tagFilter)) {
    return cards;
  }

  return cards.filter(item => item.insight.tag && item.insight.tag === tagFilter);
});

const applyTopicFilterToCards = createSelector([applyFilterToCards, topicFilter], (cards, topicFilter) => {
  if (_.isNull(topicFilter)) {
    return cards;
  }

  return cards.filter(item => item.insight.topics && _.includes(_.map(item.insight.topics.split(','), _.trim), topicFilter));
});

export const applyOrderingToCards = createSelector(
  [applyTopicFilterToCards],
  cards => {
    const sorted = _.sortBy(cards, "x");
    return _.sortBy(sorted, "y");
  }
);

export const applySelectorsToCards = createSelector(
  [applyOrderingToCards],
  cards => cards
);



// WEBPACK FOOTER //
// ./src/cardListing/selectors/cards.js